export const planets = {
  mercury: {
    name: "Mercury",
    dayTexture: '/planets/2k_mercury.jpg',
    nightTexture: '/planets/2k_mercury_night.jpg',
    specularTexture: undefined,
    atmosphereDayColor: '#888888',
    atmosphereTwilightColor: '#555555',
    hasAtmosphere: false,

    // Visual properties
    scale: 1.0,
    rotationSpeed: 0.17,
    atmosphereScale: 1.01,

    // Info card data
    description: "The smallest and fastest planet, closest to the Sun",
    diameter: "4879 km",
    distanceFromSun: "257.9 million km",
    rotationPeriod: "59 days",
    orbitalPeriod: "88 days",
    moons: 0,
    composition: "Rocky planet with large iron core",
    funFact: "Mercury has the most extreme temperature swings in the solar system, from -173°C to 427°C"
  },
  venus: {
    name: "Venus",
    dayTexture: '/planets/2k_venus_surface.jpg',
    nightTexture: '/planets/2k_venus_surface_night.jpg',
    specularTexture: undefined,
    atmosphereDayColor: '#ffddaa',
    atmosphereTwilightColor: '#ffaa66',
    hasAtmosphere: true,

    // Visual properties
    scale: 1.15,
    rotationSpeed: -0.08,
    atmosphereScale: 1.08,

    // Info card data
    description: "The hottest planet with a thick toxic atmosphere",
    diameter: "12104 km",
    distanceFromSun: "108.2 million km",
    rotationPeriod: "243 days (retrograde)",
    orbitalPeriod: "225 days",
    moons: 0,
    composition: "Rocky planet with thick CO2 atmosphere",
    funFact: "A day on Venus (243 Earth days) is longer than its year (225 Earth days), and it rotates backwards!"
  },
  earth: {
    name: "Earth",
    dayTexture: './earth/day.jpg',
    nightTexture: './earth/night.jpg',
    specularTexture: './earth/specularClouds.jpg',
    atmosphereDayColor: '#00aaff',
    atmosphereTwilightColor: '#ff6600',
    hasAtmosphere: true,

    // Visual properties
    scale: 1.2,              // Relative size (Earth = 1.0)
    rotationSpeed: 1.0,      // Relative rotation speed (Earth = 1.0)
    atmosphereScale: 1.04,   // Atmosphere thickness

    // Info card data
    description: "Our home planet, the only known world with life.",
    diameter: "12742 km",
    distanceFromSun: "149.6 million km",
    rotationPeriod: "24 hours",
    orbitalPeriod: "365.25 days",
    moons: 1,
    composition: "Rocky planet with iron core",
    funFact: "Earth is the only planet not named after a Greek or Roman deity"
  },
  mars: {
    name: "Mars",
    dayTexture: '/planets/2k_mars.jpg',
    nightTexture: '/planets/2k_mars_night.jpg',
    specularTexture: undefined,
    atmosphereDayColor: '#ff8844',
    atmosphereTwilightColor: '#cc3311',
    hasAtmosphere: true,

    // Visual properties
    scale: 1.1,
    rotationSpeed: 0.97,
    atmosphereScale: 1.02,

    // Info card data
    description: "The red planet with giant volcanoes and ancient riverbeds",
    diameter: "6779 km",
    distanceFromSun: "227.9 million km",
    rotationPeriod: "24.6 hours",
    orbitalPeriod: "687 days (1.9 years)",
    moons: 2,
    composition: "Rocky planet with thin CO2 atmosphere",
    funFact: "Mars is home to Olympus Mons, the largest volcano in the solar system at 22km high"
  },
  jupiter: {
    name: "Jupiter",
    dayTexture: '/planets/2k_jupiter.jpg',
    nightTexture: '/planets/2k_jupiter_night.jpg',
    specularTexture: undefined,
    atmosphereDayColor: '#ffcc99',
    atmosphereTwilightColor: '#dd9955',
    hasAtmosphere: true,

    // Visual properties
    scale: 1.5,
    rotationSpeed: 2.4,
    atmosphereScale: 1.05,

    // Info card data
    description: "The largest planet, a gas giant with a famous Great Red Spot",
    diameter: "139820 km",
    distanceFromSun: "778.5 million km",
    rotationPeriod: "10 hours",
    orbitalPeriod: "11.9 years",
    moons: 95,
    composition: "Gas giant made of hydrogen and helium",
    funFact: "Jupiter is so massive it could fit all the other planets inside it, and its Great Red Spot is a storm larger than Earth"
  },
  saturn: {
    name: "Saturn",
    saturnRingsTexture: '/planets/2k_saturn_ring_alpha.png',
    dayTexture: '/planets/2k_saturn.jpg',
    nightTexture: '/planets/2k_saturn_night.jpg',
    specularTexture: undefined,
    atmosphereDayColor: '#ffddbb',
    atmosphereTwilightColor: '#ddaa77',
    hasAtmosphere: true,

    // Visual properties
    scale: 1.45,
    rotationSpeed: 2.3,
    atmosphereScale: 1.05,

    // Info card data
    description: "The ringed planet with spectacular ice rings",
    diameter: "116460 km",
    distanceFromSun: "1.43 billion km",
    rotationPeriod: "10.7 hours",
    orbitalPeriod: "29.5 years",
    moons: 146,
    composition: "Gas giant with hydrogen and helium",
    funFact: "Saturn is so light it would float on water if there was an ocean big enough, and its moon Titan has liquid methane lakes"
  },
  uranus: {
    name: "Uranus",
    dayTexture: '/planets/2k_uranus.jpg',
    nightTexture: '/planets/2k_uranus_night.jpg',
    specularTexture: undefined,
    atmosphereDayColor: '#aaffee',
    atmosphereTwilightColor: '#66ccbb',
    hasAtmosphere: true,

    // Visual properties
    scale: 1.35,
    rotationSpeed: 1.4,
    atmosphereScale: 1.04,

    // Info card data
    description: "The sideways planet with an extreme axial tilt",
    diameter: "50724 km",
    distanceFromSun: "2.87 billion km",
    rotationPeriod: "17.2 hours",
    orbitalPeriod: "84 years",
    moons: 27,
    composition: "Ice giant with water, methane, and ammonia",
    funFact: "Uranus rotates on its side with an axial tilt of 98°, likely from a massive collision. Each pole gets 42 years of continuous sunlight, then 42 years of darkness!"
  },
  neptune: {
    name: "Neptune",
    dayTexture: '/planets/2k_neptune.jpg',
    nightTexture: '/planets/2k_neptune_night.jpg',
    specularTexture: undefined,
    atmosphereDayColor: '#4466ff',
    atmosphereTwilightColor: '#2244cc',
    hasAtmosphere: true,

    // Visual properties
    scale: 1.33,
    rotationSpeed: 1.5,
    atmosphereScale: 1.04,

    // Info card data
    description: "The windiest planet with supersonic storms",
    diameter: "49244 km",
    distanceFromSun: "4.5 billion km",
    rotationPeriod: "16.1 hours",
    orbitalPeriod: "165 years",
    moons: 14,
    composition: "Ice giant with hydrogen, helium, and methane",
    funFact: "Neptune has the fastest winds in the solar system at over 2,000 km/h, despite being the farthest planet from the Sun"
  },
}
